import { OPEN, CLOSE } from './actions';

export const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CLOSE: {
      return {};
    }
    case OPEN: {
      return {
        name: action.componentName,
        params: action.componentProps
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
